import { useRef } from 'react';
import { CrudForm } from '../../../../containers/crud/crudForm';
import { ApiAutoCompleteSelect } from '../../../../containers/selectComponents/apiAutoCompleteSelect';
export const WebsiteTemplatesForm = (props) => {
  const form = useRef(null);
  return (
    <CrudForm
      {...props}
      ref={form}
      elements={[
        {
          type: 'text',
          name: 'name',
          label: 'Name',
          required: true,
        },
        {
          type: 'text',
          name: 'description',
          label: 'Description',
        },
        {
          type: 'text',
          name: 'repoUrl',
          label: 'Repo Link',
          required: true,
        },
        {
          type: 'text',
          name: 'demoUrl',
          label: 'Demo Url',
        },
        {
          name: 'configFileName',
          label: 'Config File Name',
          required: true,
        },
        {
          type: 'file',
          name: 'bannerImage',
          label: 'Banner Image',
          fileCode: 'configurationFile',
          uploadProps: {
            accept: 'image/*',
          },
        },
        {
          type: 'switch',
          name: 'active',
          label: 'Active',
        },

        {
          type: 'custom',
          name: 'categoryId',
          label: 'Category',
          required: true,
          Component: ApiAutoCompleteSelect,
          inputProps: {
            api: 'categories',
            params: {
              all: true,
              search: (text) => [`name;${text};like`],
            },
          },
        },
      ]}
    />
  );
};
